import { call, put, takeLatest } from 'redux-saga/effects';
import { availableYearsService } from 'services/TAPS_API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const { isOk, data, error } = yield call(availableYearsService, action.payload);
  yield put(isOk ? requestSuccess(data) : requestFailure(error));
}

export default function* declarationAvailableYearSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
